<template>
  <modal ref="modal">
    <span slot="activator">
      <slot name="activator"></slot>
    </span>

    <div slot="header">Mark product as Delivered</div>

    <div class="header">
      <h2>
        <slot name="header"></slot>
      </h2>
    </div>

    <div class="toolbar">
      <slot name="toolbar"></slot>
    </div>

    <div class="content">
      <div class="infos">
        <div>Order N°{{ order.id_order }}</div>
        <div>Product id N° {{ value.id_product }}</div>
      </div>

      <div class="product-status-form">
        <div class="center aligned">
          <button
            :disabled="loading === true"
            class="ui button green"
            @click="showModal = true"
          >
            Mark product as Delivered
          </button>
        </div>
      </div>
    </div>
    <popup-modal
      ref="confirmProductStatusModal"
      :index="showModal"
      icon="checkmark"
      cancel_class="ui red basic cancel inverted button"
      confirm_class="ui green ok inverted button"
      text="Are you sure you want to mark this product as Delivered ?"
      @delete="updateProductStatus()"
      @cancel="showModal = null"
    ></popup-modal>
  </modal>
</template>

<style scoped>
.product-status-form {
  width: 700px;
  margin: 0 auto;
  border: 1px solid #ccf;
  border-radius: 10px;
}

.product-status-form > div {
  margin: 10px;
}

</style>

<script>
// import axios from 'axios'
import { mapGetters } from 'vuex'
import axios from "axios";

export default {
  name: 'ProductStatus',
  props: {
    // Value represent the current product to change status
    value: {
      type: Object,
      default: null
    },
    order: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showModal: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      currentCustomer: 'getCurrentCustomer'
    })
  },
  mounted() {
  },
  methods: {
    updateProductStatus() {
      this.showModal = null
      this.loading = true

      axios
        .post('/product/status', {
          id_product: this.value.id_product,
          id_order: this.order.id_order,
          status: 'Delivered'
        })
        .then((response) => {
          // eslint-disable-next-line
          console.log(response)
          this.$awn.success('Product successfully updated.')
          this.loading = false
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductStatusModal.vue?1bc33ab0